function adTypeNavigation () {
  const videoBtn = document.querySelector('.js-video-btn');
  const videoAds = document.querySelector('.js-video-ads');
  const radioBtn = document.querySelector('.js-radio-btn');
  const radioAds = document.querySelector('.js-radio-ads');
  videoBtn.classList.add('active');

  radioAds.style.display = 'none';
  videoBtn.addEventListener('click', (e) => {
    radioBtn.classList.remove('active');
    if (videoAds.style.display === 'none') {
      videoBtn.classList.add('active');
      radioAds.style.display = 'none';
      videoAds.style.display = 'flex';
    }
  });

  radioBtn.addEventListener('click', (e) => {
    videoBtn.classList.remove('active');
    if (radioAds.style.display === 'none') {
      radioBtn.classList.add('active');
      radioAds.style.display = 'flex';
      videoAds.style.display = 'none';
    }
  });
}

function adModal (ad) {
  const modalContent = document.querySelector('.modal-content');
  const modalIframe = document.querySelector('.ytframe');
  const modalVideo = document.querySelector('.modal-media__video');
  const modalAudio = document.querySelector('.modal-media__radio');
  const modalAudioPlayer = document.querySelector('.js-ad-audio-player');
  const modalAudioPlayerSrc = document.querySelector('.ad-audio-player-src');

  modalContent.querySelector('.modal-text__title').textContent = ad.parentElement.getAttribute('data-title');
  // modalContent.querySelector('.modal-text__description').textContent = ad.parentElement.getAttribute('data-description');
  modalVideo.style.display = 'none';
  modalAudio.style.display = 'none';

  if (ad.parentElement.getAttribute('data-type') === 'video') {
    modalVideo.style.display = 'flex';
    modalIframe.setAttribute('src', ad.parentElement.getAttribute('data-url'));
  } else {
    modalAudio.style.display = 'flex';
    modalAudioPlayerSrc.setAttribute('src', ad.parentElement.getAttribute('data-url'));
    modalAudioPlayer.load();
  }
}

let visible = false;
function adModalToggle (elm) {
  const modalOuter = document.querySelector('.bonkers-ads__modal-outer');
  const modal = document.querySelector('.bonkers-ads__modal');
  const animations = ['animated', 'fadeOut', 'fadeInUp', 'faster'];

  modalOuter.classList.remove(...animations);
  modal.classList.remove(...animations);

  if (visible) {
    modalOuter.classList.add('animated', 'fadeOut');
    modal.classList.add('animated', 'fadeOut');
  } else {
    modalOuter.classList.add('animated', 'fadeInUp', 'faster');
    modal.classList.add('animated', 'fadeInUp', 'faster');
  }

  modal.addEventListener('animationstart', () => {
    if (modal.classList.contains('fadeInUp')) {
      modalOuter.style.visibility = 'visible';
      modal.style.visibility = 'visible';
      visible = true;
    }
  });

  modal.addEventListener('animationend', () => {
    if (modal.classList.contains('fadeOut')) {
      modalOuter.style.visibility = 'hidden';
      modal.style.visibility = 'hidden';
      visible = false;
    }
  });

  if (elm.currentTarget.className === 'modal-close') {
    document.querySelector('iframe').setAttribute('src', '');
    document.querySelector('audio').pause();
    document.querySelector('audio').currentTime = 0;
  }
}

if (document.querySelector('.js-ad-nav')) {
  adTypeNavigation();

  const modalCLose = document.querySelector('.modal-close');
  modalCLose.addEventListener('click', (e) => adModalToggle(e));

  const radioAds = document.querySelectorAll('.radio-ad');
  const videoAds = document.querySelectorAll('.video');
  radioAds.forEach((ad) => {
    ad.addEventListener('click', (e) => {
      adModal(ad);
      adModalToggle(e);
    });
  });
  videoAds.forEach((ad) => {
    ad.addEventListener('click', (e) => {
      adModal(ad);
      adModalToggle(e);
    });
  });
}
